import { defineSlotRecipe } from '@chakra-ui/react/styled-system';

const overflowContentSlotRecipe = defineSlotRecipe({
  className: 'overflowContent',
  slots: ['root', 'preview', 'action'] as const,
  base: {
    root: {
      alignItems: 'center',
      display: 'flex',
      gap: '4',
    },
    preview: {
      flex: '1',
      minWidth: 0,
      overflow: 'hidden',
      position: 'relative',
      textOverflow: 'ellipsis',
      textStyle: 'body/md/regular',
      whiteSpace: 'nowrap',
      _after: {
        background: 'linear-gradient(to left, {colors.neutral.100} 0%, transparent 100%)',
        content: '""',
        height: '100%',
        pointerEvents: 'none',
        position: 'absolute',
        right: 0,
        top: 0,
        width: '32',
      },
    },
    action: {
      flexShrink: '0',
    },
  },
});

export default overflowContentSlotRecipe;
